export const MARBYLIZATION = 'marbylization';
export const ACTIVATION = 'activation';
